import { connect } from 'react-redux';

import SigningProgressRejectionModal from '@app/components/Modal/RejectDocumentModal';
import { modalClose } from '@app/store/modal/actions';
import { getName } from '@app/store/user/user/selectors';

const mapStateToProps = (state) => ({
  userName: getName(state),
});

const mapDispatchToProps = (dispatch) => ({
  onCancel: () => dispatch(modalClose()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SigningProgressRejectionModal);
